import routes from './routes.tsx'
import { useRoutes } from 'react-router-dom'

const App = () => {
  const content = useRoutes(routes)
  return content
}

export default App

// import { RouterProvider, createBrowserRouter } from 'react-router-dom';
// import routes from './routes'; // Import the new .ts file

// const router = createBrowserRouter(routes);

// export const App = () => {
//   return <RouterProvider router={router} />;
// };

// createBrowserRouter([
//   {
//     path: "/",
//     middleware: [loggingMiddleware],
//     loader: rootLoader,
//     Component: Root,
//     children: [{
//       path: 'auth',
//       middleware: [authMiddleware],
//       loader: authLoader,
//       Component: Auth,
//       children: [...]
//     }]
//   },
// ]);

// async function loggingMiddleware({ request }, next) {
//   let url = new URL(request.url);
//   console.log(`Starting navigation: ${url.pathname}${url.search}`);
//   const start = performance.now();
//   await next();
//   const duration = performance.now() - start;
//   console.log(`Navigation completed in ${duration}ms`);
// }

// const userContext = createContext<User>();

// async function authMiddleware ({ context }) {
//   const userId = getUserId();

//   if (!userId) {
//     throw redirect("/login");
//   }

//   context.set(userContext, await getUserById(userId));
// };
